var map = {
	"./65pie.svg": "0Trn",
	"./README.md": "yGDj",
	"./analyse-dashboard.svg": "q+ir",
	"./app-store.svg": "WPzf",
	"./apple-podcasts.svg": "aeCq",
	"./audience-engagement.svg": "gzhB",
	"./cart-no-circle.svg": "IpbL",
	"./citydoc.svg": "rEsR",
	"./clipboard.svg": "Qkcr",
	"./council.svg": "Jr+A",
	"./counselling.svg": "1e8C",
	"./delfin.svg": "FzfI",
	"./dochq-logo-rect-white.svg": "uqEc",
	"./dochq-logo-rect.svg": "UrR6",
	"./dochq-logo-sq-bg.svg": "EQrn",
	"./dochq-logo-sq.svg": "JsY7",
	"./doctor-briefcase.svg": "e1Uk",
	"./doctor-prescription.svg": "L07c",
	"./form.svg": "kdES",
	"./free-tool.svg": "trug",
	"./google-play.svg": "y9iV",
	"./health-partner.svg": "KHky",
	"./ico-logo.svg": "fYrL",
	"./menu-pink.svg": "kGiG",
	"./menu.svg": "0X8D",
	"./message.svg": "YS69",
	"./miyo.svg": "rfYy",
	"./mobile-app.svg": "CFQ/",
	"./mobile-appointment.svg": "byhy",
	"./monetize-blog.svg": "ZVXE",
	"./on-time-payments.svg": "mJVf",
	"./person.svg": "0QQZ",
	"./physiotherapy-2.svg": "Pkwc",
	"./pie-chart.svg": "l3Pa",
	"./prescription.svg": "hE38",
	"./restricted-medicines.svg": "NiV2",
	"./shieldwear.svg": "GWuK",
	"./sickness-management.svg": "6KEj",
	"./spotify-podcasts.svg": "Zxw8",
	"./stethescope.svg": "eeCw",
	"./symbiotics.svg": "4g++",
	"./synlab.svg": "tLvS",
	"./tech-partner.svg": "PCgq",
	"./traffic-partner.svg": "Yob2",
	"./travel-vaccine.svg": "uN6J",
	"./unilabs.svg": "qoWT",
	"./vaccine.svg": "/ytJ",
	"./wellness-seminar.svg": "iLlo",
	"./zero-investment.svg": "34x7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z/fl";